import React from "react";
import { Clock, ArrowRight, ArrowLeft } from "lucide-react";
import { motion } from "framer-motion";
import { useLanguage } from "../LanguageContext";
import { translations } from "../translations";

// Google Map Embed Component
const GoogleMap = () => (
  <iframe
    title="Google Map"
    className="w-full h-full rounded-lg border-0"
    loading="lazy"
    allowFullScreen
    referrerPolicy="no-referrer-when-downgrade"
    src="https://maps.google.com/maps?q=Myanmar%20City%20Bonded%20Warehouse&t=&z=15&ie=UTF8&iwloc=&output=embed"
  />
);

const TravelTimesCard = () => {
  const { language } = useLanguage();

  return (
    <div className="container mx-auto px-4 mt-6">
      {/* Responsive Grid Layout */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Google Map (Takes 2 columns on md and up) */}
        <div className="col-span-1 md:col-span-2 h-[350px]">
          <GoogleMap />
        </div>

        {/* Travel Time Card (Takes 1 column on md and up) */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="col-span-1 h-[350px]"
        >
          <div className="bg-white shadow-lg rounded-lg overflow-hidden h-full">
            {/* Header */}
            <div className="bg-blue-100 flex items-center gap-2 p-4">
              <Clock className="text-blue-600 w-5 h-5" />
              <h2 className="text-lg font-semibold text-gray-900">
                {translations[language].TravelTimes}
              </h2>
            </div>

            {/* Content */}
            <div className="flex flex-col h-[calc(100%-60px)] divide-y">
              {/* First Travel Time */}
              <div className="flex items-center gap-4 p-4 flex-1">
                <ArrowRight className="text-blue-600 w-5 h-5" />
                <div>
                  <h3 className="text-lg font-bold text-gray-900">
                    {translations[language].FromHrMin}
                  </h3>
                  <p className="text-gray-600 text-sm">
                    {" "}
                    {translations[language].From}
                  </p>
                </div>
              </div>

              {/* Second Travel Time */}
              <div className="flex items-center gap-4 p-4 flex-1">
                <ArrowLeft className="text-blue-600 w-5 h-5" />
                <div>
                  <h3 className="text-lg font-bold text-gray-900">
                    {translations[language].ToHrMin}
                  </h3>
                  <p className="text-gray-600 text-sm">
                    {translations[language].To}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default TravelTimesCard;
